import {RouteProps} from "react-router-dom";
import SearchModel from "./pages/searchmodel";
import {USER_ROLE} from "./store/user";
import Reports from "./pages/report";
import Administration from "./pages/administration";
import Maintain from "./pages/maintainmodel";
import {ReactNode} from "react";

export type RouteType = RouteProps & {
    order: number,
    name: string;
    path: string; // override string | string[]
    element: ReactNode
};

export function getRoutes(roles): RouteType[] {

    let routesMap = new Map();

    let routes = [];

    let maintainModel: RouteType = {
        order: 1,
        name: "Maintain Model",
        path: "/maintainmodel",
        element: <Maintain />
    };

    const searchNumbers: RouteType = {
        order: 2,
        name: "Search Numbers",
        path: "/search",
        element: <SearchModel />
    };

    const reports: RouteType = {
        order: 3,
        name: "Reports",
        path: "/reports",
        element: <Reports />
    };

    const administration: RouteType = {
        order: 4,
        name: "Administration",
        path: "/administration",
        element: <Administration />
    };

    roles.forEach(role => {
        switch (role) {
            case USER_ROLE.MASTER_DATA_MAINTENANCE:
                routesMap.set(1, maintainModel);
                break;

            case USER_ROLE.ORDER_MANAGEMENT:
                routesMap.set(2, searchNumbers);
                //routesMap.set(3,reports);
                break;

            case USER_ROLE.REPORTING:
                routesMap.set(3, reports);
                break;

            case USER_ROLE.VIP_ORDER_MANAGEMENT:
                routesMap.set(2, searchNumbers);
                routesMap.set(4, administration);
                //routesMap.set(3,reports);
                break;

            case USER_ROLE.IMPORTER:
            case USER_ROLE.DEALER:
                routesMap.set(2, searchNumbers);
                break;
        }
    });
    routesMap.forEach(route => {
        routes.push(route);
    });
    routes.sort(compare)
    return routes;
}

function compare(a, b) {
    if (a.order < b.order) {
        return -1;
    }
    if (a.order > b.order) {
        return 1;
    }
    return 0;
}
